module.exports = __webpack_public_path__ + "img/img19.ac9c8eef.svg";